module.exports = __webpack_public_path__ + "static/media/abstract10.ca5d7056.jpg";